function calcAmountOfMoreResults(data) {
    return data?.total - data?.limit;
}

export function AppDataReducerSearchResults(state, action) {
    const companiesMoreResults = calcAmountOfMoreResults(action.companies?.message?.meta);
    const companiesItems = (action.companies?.message?.data || []).map((data) => ({
        id: data.id,
        name: `${data.name} (${data.debtor_number})`,
    }));

    const administrationsMoreResults = calcAmountOfMoreResults(action.administrations?.message?.meta);
    const administrationsItems = (action.administrations?.message?.data || []).map((data) => ({
        id: data.id,
        name: data.name,
        companyId: data.company_id,
        licenseId: data.license_id,
        type: data.type,
        onlineStatus: data.online ? 'online' : 'offline',
    }));

    return {
        companies: {
            amountOfMoreResults: companiesMoreResults,
            items: companiesItems,
        },
        administrations: {
            amountOfMoreResults: administrationsMoreResults,
            items: administrationsItems,
        },
    };
}
